<template>
  <v-container class="pa-5 bg" fluid v-editable="blok">
    <v-row>
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <div class="title">
              <h2>{{blok.title}}</h2>

              <div class="pb-icon">
                <div class="before">
                  <span>►</span>
                </div>
                <figure>
                  <img src="@/assets/logo_mini_dark.svg" alt />
                </figure>
                <div class="after">
                  <span>◄</span>
                </div>
              </div>
            </div>
            <p class="intro mt-5">{{blok.description}}</p>
          </v-col>
        </v-row>
        <v-row justify="center" >
          <v-col cols="12" sm="6" md="5" lg="4" xl="3" class="d-flex align-stretch" v-for="(item, i) in blok.memberships" :key="i">
            <v-card class="item mx-5"  tile :dark="item.dark">
              <figure :style="'background-image: url('+item.image+')'">                
              </figure>
              <h4 class="mb-5">{{item.name}}</h4>
              <v-btn :href="item.link.url" target="_blank" color="accent" class="my-5" tile depressed large>{{item.linkName}}</v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["blok"]
};
</script>

<style lang="scss" scoped>
@import "./Memberships.scss";
</style>